import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { useUsersStore } from '../store/users'

export const followCompaniesDefinition = {
  type: filters.FOLLOW_COMPANIES,
  nameKey: 'follow_companies',
  ledgerRequired: false,

  activeSubtitle(settings, _getters) {
    if (settings.comparisonMode === CompareMixin.TYPES.CURRENT_USER) {
      return I18n.t('companies_overview.filters.follow_companies.current_user')
    }
    if (settings.comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      return I18n.t('companies_overview.filters.comparison_modes.show_all')
    }

    const usersStore = useUsersStore()
    const user = usersStore.getUserById(parseInt(settings.comparisonValue))
    return user?.name || ''
  },

  normalizeSettings(settings) {
    let comparisonValue = ''

    // set comparisonValue to UserID when comparisonMode is USER
    if (settings.comparisonMode === CompareMixin.TYPES.USER) {
      comparisonValue = settings.comparisonValue
    }

    return {
      comparisonValue: comparisonValue,
      comparisonMode: settings.comparisonMode,
    }
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
      current_user_id: Silverfin.currentUserId(),
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
    }
  },
}
